"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var core_1 = require("@material-ui/core");
var Mustache = __importStar(require("mustache"));
var useStyles = core_1.makeStyles(function (theme) { return ({
    avatar: {
        width: 30,
        height: 30
    },
    answer: { marginLeft: 15 },
    header: {
        backgroundColor: theme.palette.primary.main,
        height: 50,
        color: theme.palette.primary.contrastText
    },
    title: {
        fontSize: 14
    },
    actions: {
        display: 'flex'
    },
    button: {
        flex: 1
    }
}); });
exports.Questionnaire = function (_a) {
    var feedbackYes = _a.feedbackYes, feedbackNo = _a.feedbackNo, operatorEscalationUrl = _a.operatorEscalationUrl, onFeedback = _a.onFeedback;
    var classes = useStyles();
    var _b = react_1.default.useState('notSelected'), state = _b[0], setState = _b[1];
    var messages = {
        notSelected: '上記Q＆Aは参考になりましたか?',
        yes: feedbackYes,
        no: feedbackNo
    };
    var feedback = function (action) {
        onFeedback(action, function () { return setState(action); });
    };
    return (react_1.default.createElement(core_1.Card, { className: "faq-questionnaire" },
        react_1.default.createElement(core_1.CardContent, null,
            react_1.default.createElement(core_1.Typography, { className: classes.title, color: "textSecondary", align: "left", gutterBottom: true, dangerouslySetInnerHTML: { __html: Mustache.render(messages[state], { operatorEscalationUrl: operatorEscalationUrl }) } })),
        state !== 'notSelected' ? null : (react_1.default.createElement(core_1.CardActions, { className: clsx_1.default('faq-actions', classes.actions) },
            react_1.default.createElement(core_1.Button, { className: clsx_1.default('faq-button', classes.button), variant: "contained", color: "secondary", size: "small", onClick: function () { return feedback('yes'); } }, "\u306F\u3044"),
            react_1.default.createElement(core_1.Button, { className: clsx_1.default('faq-button', classes.button), variant: "contained", color: "secondary", size: "small", onClick: function () { return feedback('no'); } }, "\u3044\u3044\u3048")))));
};
//# sourceMappingURL=Questionnaire.js.map